import React from "react";
import Jumbotron from "react-bootstrap/Jumbotron";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import "./contact-form.styles.css";

const ContactForm = () => {
  return (
    <div id="contact">
      <h1 className="pt-3 text-center font-details-b ">CONTACT ME</h1>
      <Jumbotron className="contact-jumbotron">
        <Row>
        {/* <Col className="d-flex justify-content-center flex-wrap mt-5"> */}
          <Col className="d-flex justify-content-center flex-wrap mt-5">
            <div className="m-2">
              <a href="mailto:ayushat.0202@gmail.com?subject=From Portfolio&body=Hello User..!!Glad you are here"  target="_blank" rel="noopener noreferrer">
                <Button variant="outline-danger" title="ayushat.0202@gmail.com">
                  <i className="fas fa-envelope-square"></i> Email Me
                </Button>
              </a>
            </div>
            {/* <div className="m-2">
              <a href="" target="_blank" rel="noopener noreferrer">
                <Button variant="outline-primary" title="Visit my LinkenIn">
                  <i className="fab fa-linkedin"></i> LinkedIn
                </Button>
              </a>
            </div> */}
            <div className="m-2">
              <a href="https://www.facebook.com/ayushliberty/" target="_blank" rel="noopener noreferrer">
                <Button variant="outline-primary" title="Say hello on FB">
                  <i className="fab fa-facebook-square"></i> FaceBook
                </Button>
              </a>
            </div>
            <div className="m-2">
              <a href="https://github.com/ayushat" target="_blank" rel="noopener noreferrer">
                <Button variant="outline-dark" title="My other projects">
                  <i className="fab fa-github-square"></i> GitHub
                </Button>
              </a>
            </div>
            <div className="m-2">
              <a href="https://www.instagram.com/ayush6282/?hl=en" target="_blank" rel="noopener noreferrer">
                <Button variant="outline-danger" title="Requests are welcomed!">
                  <i className="fab fa-instagram"></i> Instagram
                </Button>
              </a>
            </div>
          </Col>
          
        
          {/* <hr className="hr-v" /> */}

          {/* <Col className="d-flex justify-content-start flex-wrap mt-5">
          <form name="contact-form" method="post" data-netlify="true" netlify-honeypot="bot-field">
                    <input type="hidden" name="form-name" value="contact-form"/>
                    <div className="form-group">
                        <input
                            className="form-control rounded-pill"
                            type="text"
                            name="name"
                            id="name"
                            placeholder="Your Name Here"
                            minLength="3"
                            required
                            
                        />
                        
                    </div>
                    <div className="form-group">
                    <input
                            className="form-control rounded-pill"
                            aria-describedby="emailHelp"
                            type="email"
                            name="email"
                            id="email"
                            placeholder="Your Email Here"
                            required
                        />
                        <small id="emailHelp" class="form-text text-muted">Your email is safe with us.</small>
                    </div>

                        
                    <div className="form-group">
                    <input
                            className="form-control rounded-pill"
                            type="text"
                            aria-describedby = "phoneHelp"
                            name="phone"
                            id="phone"
                            placeholder="Your Contact Number Here"
                            maxLength="12"
                        />
                        <small id="phoneHelp" class="form-text text-muted">+32-123-456-7890</small>

                    </div>
                         
                    <div className="form-group">
                        <textarea
                                className="form-control rounded"
                                type="text"
                                name="description"
                                id="description"
                                placeholder="Your Message Here"
                                minLength="10"
                            />


                    </div>

                       <button type="submit" className="btn btn-block btn-info ">Submit</button>
                </form>
              </Col> */}
            {/* </Col> */}
        </Row>
      </Jumbotron>
    </div>
  );
};

export default ContactForm;
